import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useHasUserFeatures } from '#app/hooks/useHasUserFeatures.js';
import { useHasUserGroups } from '#app/hooks/useHasUserGroups.js';

export const useSocialPostAccess = (): {
  readonly canBoostSocialPost: boolean;
  readonly canDeleteSocialPost: boolean;
  readonly canEngage: boolean;
  readonly canFeatureSocialPost: boolean;
  readonly canPost: boolean;
  readonly canViewFeed: boolean;
} => {
  const currentUser = useCurrentUser();
  const canPost = useHasUserFeatures('COMMUNITY_FEED_CAN_POST');
  const canViewFeed = useHasUserFeatures('COMMUNITY_FEED_CAN_VIEW_FEED');
  const canBoostSocialPost = useHasUserFeatures(
    'COMMUNITY_FEED_CAN_BOOST_SOCIAL_POST',
  );
  const canDeleteSocialPost = useHasUserFeatures(
    'COMMUNITY_FEED_CAN_DELETE_SOCIAL_POST',
  );
  const canFeatureSocialPost = useHasUserFeatures(
    'COMMUNITY_FEED_CAN_FEATURE_SOCIAL_POST',
  );
  const canEngageAsClient = useHasUserGroups('CLIENT_ONBOARDING_COMPLETE');
  const canEngageAsContractor = useHasUserGroups(
    'CONTRACTOR_ONBOARDING_COMPLETE',
  );
  const canEngage = canEngageAsClient || canEngageAsContractor;

  if (!currentUser) {
    return {
      canBoostSocialPost: false,
      canDeleteSocialPost: false,
      canEngage: false,
      canFeatureSocialPost: false,
      canPost: false,
      canViewFeed: false,
    };
  }

  return {
    canBoostSocialPost,
    canDeleteSocialPost,
    canEngage,
    canFeatureSocialPost,
    canPost,
    canViewFeed,
  };
};
